// APP Specific Error Validation Localizations
// eslint-disable-next-line no-unused-vars
export default function getValidationLocalizations(i18n) {
    return {
        fields: { },
        names: { },
    };
}
